import View from 'ln/view/View';
import UserFileModel from '../models/UserFileModel';
import UserSequenceModel from '../models/UserSequenceModel';
import SlrgUserSequenceModel from '../models/SlrgUserSequenceModel';


class UserFileView extends View {

	public sequence:UserSequenceModel|SlrgUserSequenceModel;

	constructor( public model:UserFileModel, sequence:UserSequenceModel|SlrgUserSequenceModel ) {
		super();
		this.sequence = sequence;

		this.defaultTemplate = 'krw.userfile';
	}
	
	public init(){

		// listen for changes
		this.node.js( 'confirm-yes' ).click.add( this.onVerifyDelete, this );
		this.node.js( 'confirm-no' ).click.add( this.onAbort, this ); 
		this.node.js( 'delete' ).click.add( this.onDelete, this );
	}

	protected renderData(){
		return this.model;
	}
	
	private onDelete(){
		this.toggleButtons();
	}

	private onVerifyDelete(){
		this.sequence.userfiles.remove( this.model );
	}

	private onAbort(){
		this.toggleButtons();
	}

	private toggleButtons(){
		this.node.js( 'delete' ).toggleClass( 'hidden' );
		this.node.js( 'verify-delete' ).toggleClass( 'hidden' );
	}

}

export default UserFileView;